import styles from './future-change-icon.module.scss';
import { ContractOrderTypesEnum, IOrderItem } from '../common-types/common-types';
import Icon from '../icon/icon';
import { dateFormatter } from '../table-helpers/table-helpers';
import Tooltip from '../tooltip/tooltip';

/* eslint-disable-next-line */
export interface FutureChangeIconProps {
  item: IOrderItem,
  isModule?: boolean
}

export function FutureChangeIcon(props: FutureChangeIconProps) {
  const getMessage = () => {
    if (props.item.type === ContractOrderTypesEnum.AddSeats)
      return `${props.item.quantity} seter ${props.item.quantity > 0 ? "legges til" : "fjernes"} ${props.isModule ? "fra modul" : ""} ${dateFormatter(props.item.activationDate, true)}`;
    if (props.item.type === ContractOrderTypesEnum.TerminateLicense)
      return `Lisens avsluttes ${dateFormatter(props.item.activationDate, true)}`;

    return `Ukjent endring ${(props.item.type)} skjer ${dateFormatter(props.item.activationDate, true)}`;
  }
  const getIcon = () => {
    if (props.item.type === ContractOrderTypesEnum.AddSeats) return "info";
    if (props.item.type === ContractOrderTypesEnum.TerminateLicense) return "priority_high";
    return "info";
  }
  return (
    <Tooltip
      arrow
      title={getMessage()}>
      <Icon
        color='info'
        className="d-flex align-items-center material-icons-outlined ms-2">
        {getIcon()}
      </Icon>
    </Tooltip>
  );
}

export default FutureChangeIcon;